<template>
    <div layout="column" layout-align="center center" class="login-container" flex>
        <div layout="column" layout-align="center center" class="width-100-mobile" flex>
            <div layout="row" layout-align="center center" class="hidden-sm-and-down">
                <img src="@/assets/logo.png" style="max-height: 300px; position: relative; top: -30px; background: white">
            </div>
            <v-card class="login-card mb-5" flat>
                <v-card-text layout="column">
                    <v-form @submit.prevent="validate" layout="column" class="mx5-pc">
                        <div class="title secondary--text font-weight-medium text-uppercase my-4">{{$t("login.reset_title")}}</div>
                        <v-subheader class="pl-0">
                            {{$t("login.new_pw")}}
                        </v-subheader>
                        <v-text-field type="password"  outline :label="$t('login.pw2')" single-line flex v-model="form.password" required></v-text-field>
                    </v-form>
                </v-card-text>

                <v-card-actions layout="row" layout-align="end center" class="mx5-pc mr2-mobile mb-3">
                    <router-link href="#" class="black--text mr-3" :to="{name: 'login'}">{{$t("login.back")}}</router-link>
                    <v-btn depressed color="primary" large @click="validate">{{$t("_.validate")}}</v-btn>
                </v-card-actions>
            </v-card>
            <div class="hidden-sm-and-down upper-relative full-width text-xs-center" style="background: white">
                {{$t("_.supported")}}
            </div>
            <div class="hidden-sm-and-down upper-relative" layout="row" layout-align="center center">
                <img src="@/assets/GOUV_MENJE.png" style="background: white" width="400">
            </div>
        </div>
    </div>
</template>
<script>
    import ResetPasswords from '~/api/reset-passwords'
    export default {
        data () {
            return {
                form: {
                    password: ''
                }
            }
        },
        methods: {
            validate () {
                ResetPasswords.resetPassword(this.$route.params.id, this.form).then(() => {
                    this.$snotify.success(this.$t("login.updated"));
                    this.$router.push('/login');
                })
            }
        }
    }
</script>
<style scoped>
.login-card {
  width: 600px;
  background-color: rgba(241, 241, 241, 0.7);
}

.login-container {
  /*background: url('/home.png') no-repeat center center;*/
  background-size: cover;
  position: relative;
  padding-bottom: 50px;
}

.upper-relative {
  position: relative;
  top: -60px;
}

@media screen and (max-width: 960px) {
  .login-card {
    width: 100%;
  }

  .login-container {
    padding-bottom: 0px;
  }

  body,
  html {
    overflow: hidden;
  }
}
@media screen and (min-width: 960px) {
  .login-card {
    top: -60px;
  }
}
</style>